module.exports = __webpack_public_path__ + "assets/img/duoyang_3.d9fed125.png";